import { Injectable } from '@angular/core';
import { AbstractCRUD, ExceptionService, UtilsService } from '../../xform-compat';
import { BasicListModel } from '../../shared/models';
import { HttpClient } from '@angular/common/http';
import { StructCapCRMItem } from '../../shared/models/crm/struct-cap/StructCapCRMItem.model';
import { StructCapCRMStatus, StructCapCRMStatusLabels } from '../../shared/enums/struct-cap-crm-status';


@Injectable({
  providedIn: 'root'
})
export class StructCapCrmStatusService extends AbstractCRUD<BasicListModel> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService,
  ) {
    super(exceptionService, http, utilsService);
  }

  public getCurrentStage(crmItem: StructCapCRMItem): number {
    switch (crmItem.status) {
      case StructCapCRMStatus.INITIAL_INBOUND:
      case StructCapCRMStatus.NDA_IN_PROCESS:
      case StructCapCRMStatus.EARLY_REVIEW:
      case StructCapCRMStatus.DEAL_TEAM_WORKING_UP:
      case StructCapCRMStatus.TERM_SHEET_SENT:
      case StructCapCRMStatus.TERM_SHEET_SIGNED:
      case StructCapCRMStatus.CLOSED:
      case StructCapCRMStatus.FOLLOW_UP_REACTIVATED:
        return 0;
      case StructCapCRMStatus.ON_HOLD:
        return 1;
      case StructCapCRMStatus.DEAD:
        return 2;
      case StructCapCRMStatus.PASSED_FLAGGED_FOR_FOLLOW_UP:
        return 3;
    }
  }

  public getStages(): Array<string> {
    return ['Active', 'On Hold', 'Dead', 'Silenced'];
  }

  public getStatusLabel(crmItem: StructCapCRMItem): Array<string> {
    return [StructCapCRMStatusLabels[crmItem.status]];
  }

  getResourcePath(): string {
    return '';
  }

  public isSilenceStatus(status: StructCapCRMStatus): boolean {
    return status === StructCapCRMStatus.PASSED_FLAGGED_FOR_FOLLOW_UP;
  }
}
